import styled, { css } from 'styled-components';

const TEMP_PADDING_BOTTOM = 100;

interface ContentProps {
    $columns: number;
}

export const ManagerGridWrapper = styled.div`
    padding-bottom: ${TEMP_PADDING_BOTTOM}px;
`;

export const Content = styled.div<ContentProps>`
    display: grid;
    gap: 40px;

    ${({ $columns }) =>
        $columns &&
        css`
            grid-template-columns: repeat(${$columns}, minmax(0, 1fr));
        `}
`;

export const Pagination = styled.div`
    margin-top: 40px;
    width: 100%;
    text-align: center;
`;
